const MenuClose = ({ color = '#fff' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 21L14 14" stroke={color} strokeWidth="2" />
      <path d="M3 21L10 14" stroke={color} strokeWidth="2" />
      <path d="M21 3L14 10" stroke={color} strokeWidth="2" />
      <path d="M3 3L10 10" stroke={color} strokeWidth="2" />
    </svg>
  )
}

export default MenuClose
